import { FormItemTypes, IDictionary } from '@bimser/core';
import { IPropertyField } from '../../../../entities/common';
import VisualControl from '../../base/VisualControl';
import { EDataSynchronizerSourceType } from './entities/EDataSynchronizerSourceType';
import { EDataSynchronizerTargetType } from './entities/EDataSynchronizerTargetType';
import { IDataSynchronizerProperties } from './entities/IDataSynchronizerProperties';
import { DataSynchronizerSource } from './entities/IDataSynchronizerSource';
import { DataSynchronizerTarget } from './entities/IDataSynchronizerTarget';

export default class DataSynchronizer extends VisualControl {
	source: DataSynchronizerSource;
	target: DataSynchronizerTarget;
	triggerEvent: string;

	constructor() {
		super();

		this.controlType = FormItemTypes.EControlTypes.DataSynchronizer;

		this.source = {
			type: EDataSynchronizerSourceType.Control,
			path: '',
			dataSource: {
				fileId: null,
				displayExpr: [],
				valueExpr: null,
				name: null,
				runAtServer: false,
				parameters: []
			}
		};

		this.target = {
			type: EDataSynchronizerTargetType.Control,
			mapping: {}
		};

		this.triggerEvent = '';
		this.caption.visible = false;
	}

	__loadProperties(data: IDataSynchronizerProperties): void {
		super.__loadProperties(data);

		if (data.source) {
			this.__proxyChanged.source.type = data.source.type;
			this.__proxyChanged.source.path = data.source.path;
			this.__proxyChanged.source.dataSource = data.source.dataSource;
		}

		if (data.target) {
			this.__proxyChanged.target.type = data.target.type;
			this.__proxyChanged.target.mapping = data.target.mapping;
		}

		this.__proxyChanged.triggerEvent = data.triggerEvent;
	}

	__getPropertyFields(): IPropertyField[] {
		return [
			...super.__getPropertyFields(),
			{
				name: 'source',
				type: 'object',
				items: [
					{
						name: 'type',
						type: 'enum',
						enumMembers: [
							EDataSynchronizerSourceType.Control.toString(),
							EDataSynchronizerSourceType.DataSource.toString()
						]
					},
					{
						name: 'path',
						type: 'string'
					}
				]
			},
			{
				name: 'target',
				type: 'object',
				items: [
					{
						name: 'type',
						type: 'enum',
						enumMembers: [EDataSynchronizerTargetType.Control.toString()]
					},
					{
						name: 'mapping',
						type: 'object'
					}
				]
			},
			{
				name: 'triggerEvent',
				type: 'string'
			}
		];
	}

	__getComponentData(): IDictionary<any> {
		return {
			...super.__getComponentData(),
			target: this.target,
			source: this.source,
			triggerEvent: this.triggerEvent
		};
	}

	__onLoad(): void {
		if (
			this.triggerEvent &&
			this.source.path &&
			Object.keys(this.target.mapping).length &&
			this.__form.displayMode === 'execution'
		) {
			const [id, _, event] = this.triggerEvent.split('.');

			this.__form.controlMap[id].subscribe(`event:${event}`, () => {
				this.__form.__runServerEvent({
					name: 'SourceValueChanged',
					controlId: this.name,
					sender: 'web',
					argument: {}
				});
			});
		}
	}

	__render() {
		return super.__render(<></>);
	}
}
